import React from 'react';

import ProjectForm from '../../components/ProjectForm'

import {
    Card,
    PageHeader
} from 'antd'

export default class ProjectNew extends React.Component {

    render() {
        return(
            <div>
                <PageHeader
                    // onBack={() => null}
                    title="新建项目"
                    subTitle="This is a subtitle"
                />
                <div
                    style={{
                        margin: '24px 24px 0',
                        width: '800px'
                    }}
                >
                    <Card bordered={false}>
                        <ProjectForm />
                    </Card>
                </div>
            </div>
        )
    }
}